import React, { FC } from 'react';
import styled, { css } from 'styled-components';

import { mediaQuery } from 'src/themes/breakpoints';

const Wrapper = styled.main<LayoutProps>`
  margin: 0 auto;
  max-width: 1200px;
  padding: 100px 20px 60px;

  ${({ $layout }) =>
    $layout === 'Post' &&
    css`
      & h2,
      & h3,
      & h4,
      & h5,
      & h6 {
        display: block;
        padding-top: 60px;
      }
    `}

  ${({ $layout }) =>
    $layout === 'Blog' &&
    css`
      & h1 {
        margin-bottom: 30px;
        text-align: center;
      }
    `}

    ${({ $layout }) =>
    $layout === 'Inner-page' &&
    css`
      & h2 {
        display: block;
        padding-top: 30px;
      }
    `}

  ${mediaQuery('md')} {
    padding: 140px 20px 100px;

    ${({ $layout }) =>
      $layout === 'Blog' &&
      css`
        & h1 {
          margin-bottom: 60px;
        }
      `}

    ${({ $layout }) =>
      $layout === 'Inner-page' &&
      css`
        & p {
          padding-left: 100px;
        }
        & h2 {
          padding-top: 60px;
        }
      `}
  }
`;

interface LayoutProps {
  children: any;
  layout?: 'Inner-page' | 'Blog' | 'Post';
}

const Layout: FC<LayoutProps> = ({ children, layout }) => (
  <Wrapper $layout={layout}>{children}</Wrapper>
);

export default Layout;
